import type { ContentHref, ContentWith$$Relations } from '@generalTypes/apiTypes';
import { selectApiWithPendingChangesWithoutDeletes } from '@newStore/documentApi/documentApiSelectors';
import { createTypedSelector, getAttachmentUrl } from '@newStore/genericHelpers';
import { add$$RelationsToContent } from '../documentApi/documentApiHelpers';
import { selectCurrentDocumentHref } from '../documentUI/documentUISelectors';

export const selectPostmessageData = createTypedSelector(
  [
    (state) => selectApiWithPendingChangesWithoutDeletes(state),
    (state) => selectCurrentDocumentHref(state),
  ],
  (apiWithPendingChanges, rootHref) => {
    if (!rootHref || !apiWithPendingChanges.content[rootHref]) {
      return null;
    }

    const { from, to } = apiWithPendingChanges.relationsToAndFromMap;
    const contentMapWithRelations = add$$RelationsToContent(
      apiWithPendingChanges.content,
      from,
      to,
    );

    const content = Object.values(contentMapWithRelations)
      .map((item) => {
        if (item.$$meta) {
          return item;
        }

        const $$meta = { permalink: `/content/${item.key}` as ContentHref, type: 'CONTENT' };
        return { ...item, $$meta };
      })
      .map((item) => {
        const attachments = item.attachments?.map((attachment) => {
          const $$url = getAttachmentUrl(attachment);

          return { ...attachment, href: $$url, $$url };
        });
        // get html from content type attachment
        const contentWithTransformedAtt = { ...item, attachments };
        return contentWithTransformedAtt;
      }) as ContentWith$$Relations[];

    const data = {
      items: content,
      documentHref: rootHref,
      webpages: apiWithPendingChanges.webPages,
    };

    return { type: 'REDACTIE_SUGGESTIONS', suggestions: data };
  },
);
